'use es6';

import { get } from 'crm_data/api/ImmutableAPI';
const URI = 'sales-views/v1/associated-open-objects';
const makeURI = (...args) => {
  return `${URI}/${args.join('/')}`;
};
export function fetch(objectType, subjectId, objectTypeToFetch) {
  return get(makeURI(objectType, subjectId, objectTypeToFetch));
}